import { useNameValidation } from '@hooks/input-validation-hook';
import { Input, useTranslation } from '@testsigma/atoms';
import { useState } from 'react';

interface UploadFileVersionProps {
  fileVersion: string;
  onChangeFileVersion: (fileVersion: string) => void;
  isUploadInProgress: boolean;
}

export const UploadFileVersionPanel: React.FC<UploadFileVersionProps> = ({
  fileVersion,
  onChangeFileVersion,
  isUploadInProgress,
}) => {
  const { t } = useTranslation();
  const [errorText, setErrorText] = useState('');

  const { validateName } = useNameValidation();

  const onChange = (fileVersion) => {
    validateName(t, fileVersion, t('common.version'), setErrorText, 1, 255);
    onChangeFileVersion(fileVersion);
  };

  return (
    <Input
      value={fileVersion}
      onChange={onChange}
      type='text'
      label={t('common.version')}
      wrapperClassName='w-full'
      isRequired={true}
      hasError={!!errorText}
      preventDefaultValue
      errorText={errorText}
      isDisabled={isUploadInProgress}
    />
  );
};
